import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@brg/ui";
import { useDispatch } from "react-redux";
import {
  TagsSearchInput,
  TagsSearchInputWrapper,
  InputSmallCaption,
  SearchIconWrapper,
} from "../styles.mobile";
import { Icon } from "@brg/icons-next";
import { debounceEvent } from "shared/utils/debounce";
import styled from "styled-components";
import { LayoutConst } from "core/modules";
import { TagsActions } from "shared/reducers/Tags";

const StyledTagsSearchInput = styled(TagsSearchInput)`
  flex: 1;
  min-width: 0;
`;

const ClearSearchButton = styled.button`
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  margin-left: auto;
  flex-shrink: 0;
`;

const ClearSearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_19454_17501)">
      <path d="M7.9999 9.03564L1.72535 15.3102C1.47255 15.563 1.06065 15.5644 0.812094 15.3075C0.756406 15.2499 0.725178 15.2165 0.706523 15.1957C0.463197 14.925 0.4441 14.52 0.701494 14.2626L6.96417 7.9999L0.6896 1.72534C0.4368 1.47254 0.4368 1.06267 0.6896 0.809868L0.809867 0.689601C1.06267 0.4368 1.47254 0.4368 1.72534 0.689601L7.9999 6.96417L14.2745 0.689601C14.5273 0.4368 14.9371 0.4368 15.1899 0.689601L15.3102 0.809868C15.563 1.06267 15.563 1.47254 15.3102 1.72534L9.03564 7.9999L15.3102 14.2745C15.563 14.5273 15.5644 14.9392 15.3075 15.1877C15.2499 15.2434 15.2165 15.2746 15.1957 15.2933C14.925 15.5366 14.52 15.5557 14.2626 15.2983L7.9999 9.03564Z" fill="#909090"/>
    </g>
    <defs>
      <clipPath id="clip0_19454_17501">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

interface TagsSearchInputComponentProps {
  mainSearchRef: React.RefObject<any>;
  onInputText: (e: any) => void;
  isMobileMenu?: boolean;
  showCaption?: boolean;
  captionText?: string;
  value?: string;
  onChange?: (e: any) => void;
  onClear?: () => void;
}

export const TagsSearchInputComponent: FC<TagsSearchInputComponentProps> = ({
  mainSearchRef,
  onInputText,
  isMobileMenu,
  showCaption = false,
  captionText,
  value,
  onChange,
  onClear,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value ?? "");

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
    onChange?.(e);
  };

  const handleClearClick = () => {
    setInputValue("");
    dispatch(TagsActions.setSearchText(""));
  };

  return (
    <>
      <TagsSearchInputWrapper offsetTop={20} isMobileMenu={isMobileMenu}>
        <SearchIconWrapper isMobileMenu={isMobileMenu}>
          <Icon.Search24 />
        </SearchIconWrapper>
        <StyledTagsSearchInput
          ref={mainSearchRef}
          value={inputValue}
          onChange={handleChange}
          onInput={debounceEvent(onInputText, 1000)}
          placeholder={t(isMobile ? "tags_modal.search_mobile" : "search")}
        />
        {inputValue.length > 0 && (
          <ClearSearchButton type="button" onClick={handleClearClick} aria-label="Clear search">
            <ClearSearchIcon />
          </ClearSearchButton>
        )}
      </TagsSearchInputWrapper>
      {showCaption && (
        <InputSmallCaption>
          {captionText || t('select_tag_list')}
        </InputSmallCaption>
      )}
    </>
  );
};
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@brg/ui";
import { useDispatch } from "react-redux";
import {
  TagsSearchInput,
  TagsSearchInputWrapper,
  InputSmallCaption,
  SearchIconWrapper,
} from "../styles.mobile";
import { Icon } from "@brg/icons-next";
import { debounceEvent } from "shared/utils/debounce";
import styled from "styled-components";
import { LayoutConst } from "core/modules";
import { TagsActions } from "shared/reducers/Tags";

const StyledTagsSearchInput = styled(TagsSearchInput)`
  flex: 1;
  min-width: 0;
`;

const ClearSearchButton = styled.button`
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
  margin-left: auto;
  flex-shrink: 0;
`;

const ClearSearchIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_19454_17501)">
      <path d="M7.9999 9.03564L1.72535 15.3102C1.47255 15.563 1.06065 15.5644 0.812094 15.3075C0.756406 15.2499 0.725178 15.2165 0.706523 15.1957C0.463197 14.925 0.4441 14.52 0.701494 14.2626L6.96417 7.9999L0.6896 1.72534C0.4368 1.47254 0.4368 1.06267 0.6896 0.809868L0.809867 0.689601C1.06267 0.4368 1.47254 0.4368 1.72534 0.689601L7.9999 6.96417L14.2745 0.689601C14.5273 0.4368 14.9371 0.4368 15.1899 0.689601L15.3102 0.809868C15.563 1.06267 15.563 1.47254 15.3102 1.72534L9.03564 7.9999L15.3102 14.2745C15.563 14.5273 15.5644 14.9392 15.3075 15.1877C15.2499 15.2434 15.2165 15.2746 15.1957 15.2933C14.925 15.5366 14.52 15.5557 14.2626 15.2983L7.9999 9.03564Z" fill="#909090"/>
    </g>
    <defs>
      <clipPath id="clip0_19454_17501">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

interface TagsSearchInputComponentProps {
  mainSearchRef: React.RefObject<any>;
  onInputText: (e: any) => void;
  isMobileMenu?: boolean;
  showCaption?: boolean;
  captionText?: string;
  value?: string;
  onChange?: (e: any) => void;
  onClear?: () => void;
}

export const TagsSearchInputComponent: FC<TagsSearchInputComponentProps> = ({
  mainSearchRef,
  onInputText,
  isMobileMenu,
  showCaption = false,
  captionText,
  value,
  onChange,
  onClear,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState(value ?? "");

  const handleChange = (e: any) => {
    setInputValue(e.target.value);
    onChange?.(e);
  };

  const handleClearClick = () => {
    setInputValue("");
    dispatch(TagsActions.setSearchText(""));
  };

  return (
    <>
      <TagsSearchInputWrapper offsetTop={20} isMobileMenu={isMobileMenu}>
        <SearchIconWrapper isMobileMenu={isMobileMenu}>
          <Icon.Search24 />
        </SearchIconWrapper>
        <StyledTagsSearchInput
          ref={mainSearchRef}
          value={inputValue}
          onChange={handleChange}
          onInput={debounceEvent(onInputText, 1000)}
          placeholder={t(isMobile ? "tags_modal.search_mobile" : "search")}
        />
        {inputValue.length > 0 && (
          <ClearSearchButton type="button" onClick={handleClearClick} aria-label="Clear search">
            <ClearSearchIcon />
          </ClearSearchButton>
        )}
      </TagsSearchInputWrapper>
      {showCaption && (
        <InputSmallCaption>
          {captionText || t('select_tag_list')}
        </InputSmallCaption>
      )}
    </>
  );
};
